export default __webpack_public_path__ + "static/media/exploration-others.2d72e67f.svg";